/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Physio_TitleInputs */

const en_for_whom_physio_title = /** @type {(inputs: For_Whom_Physio_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close by between visits too.`)
};

const pl_for_whom_physio_title = /** @type {(inputs: For_Whom_Physio_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Między wizytami też jesteś obok.`)
};

/**
* | output |
* | --- |
* | "Close by between visits too." |
*
* @param {For_Whom_Physio_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_physio_title = /** @type {((inputs?: For_Whom_Physio_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Physio_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_physio_title(inputs)
	return en_for_whom_physio_title(inputs)
});